<template>
  <div class="change-passwordpage">
    <ul class="breadcrumbs-list">
      <a href="javascript:void(0)" @click="backButton"><li>Edit Profile</li></a>
      <li>&nbsp;>&nbsp;Change Password</li>
    </ul>

  <form @submit.prevent class="login-form-box change-password-page">
  <h4 class="welcome-text change-password-text">Change Password</h4>
    <div class="change-password-pagebox">
      <h5>Enter Details</h5>
        <v-row>
          <v-col class="passwordbox">
            <v-text-field 
             type="password"
             v-model="old_password"
             :error-messages="old_passwordErrors"
             label="Current Password*"
             @input="$v.old_password.$touch()"
             @blur="$v.old_password.$touch()"
             @click:append="show_password = !show_password"
             placeholder="Password"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="passwordbox">
            <v-text-field
            :type="show_new_password ? 'text' : 'password'"
             v-model="new_password"
             :error-messages="new_passwordErrors"
             label="New Password*"
             :append-icon="show_new_password ? 'mdi-eye' : 'mdi-eye-off'"
             @input="$v.new_password.$touch()"
             @blur="$v.new_password.$touch()"
             @click:append="show_new_password = !show_new_password"
             placeholder="New Password"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="passwordbox">
            <v-text-field
            :type="show_confirm_new_password ? 'text' : 'password'"
             v-model="confirm_new_password"
             :error-messages="confirm_new_passwordErrors"
             label="Confirm new password*"
             :append-icon="show_confirm_new_password ? 'mdi-eye' : 'mdi-eye-off'"
             @input="$v.confirm_new_password.$touch()"
             @blur="$v.confirm_new_password.$touch()"
             @click:append="show_confirm_new_password = !show_confirm_new_password"
             placeholder="Confirm new Password"
            ></v-text-field>
          </v-col>
        </v-row>
         <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" >{{serverError}}</span>
        <v-row class="button-row">
          <v-col>
            <v-btn
              class="blue-border-btn btn"
              @click="backButton"
            >
              Cancel
            </v-btn>
            <v-btn
              class="blue-btn btn"
              @click="submit"
              :disabled="!isFormValid"
              :error-messages="buttonErrorMessage"
            >
              UPDATE
            </v-btn>
        </v-col>
        </v-row>
    </div>
  </form>
</div>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required, email, minLength, sameAs, isAlphanumeric } from "vuelidate/lib/validators";
    import { Auth } from 'aws-amplify';
    import { CHANGE_PASSWORD } from "../store/actions.type";

  export default {
    /*async beforeCreate() {
       try {
         const user = await Auth.currentAuthenticatedUser()
       }
       catch (err) {
         this.$router.push({ name: 'Login' }).catch(()=>{});
       }
     },*/
    mixins: [validationMixin],

    validations: {
      old_password:  {required},
      new_password: { 
      required,
      minLength: minLength(8),
      validateString: function(value) {
        const containsUppercase = /[A-Z]/.test(value)
        const containsLowercase = /[a-z]/.test(value)
        const containsNumber    = /[0-9]/.test(value)
        const containsSpecial   = /[#?!@$%^&*-]/.test(value)
        return containsUppercase && containsLowercase && containsNumber && containsSpecial
      } 
    },
    confirm_new_password:{ required, sameAsPassword: sameAs('new_password')},
    },

    data: () => ({
      old_password:'',
      new_password:'',
      confirm_new_password:'',
      passwordType:'password',
      passwordType1:'password',
      submitted: false,
      status: 'Show Password',
      status1: 'Show Password',
      btnText: 'Show',
      btnText1: 'Show',
      show_password:false,
      show_new_password:false,
      show_confirm_new_password:false,
      isFormValid:false,
      serverError:'',
      isAddClassServerError:false,
      email:'',
      name:'',
      mobile_no:'',
    }),

    computed: {
      old_passwordErrors () {
        const errors = []
        this.serverError = '';
        this.isAddClassServerError = '';
        if (!this.$v.old_password.$dirty) return errors
        !this.$v.old_password.required && errors.push('Current password is required.')
        return errors
      },
      new_passwordErrors () {
        const errors = [];
        this.serverError = '';
        this.isAddClassServerError = '';
      if (!this.$v.new_password.$dirty) return errors;
      !this.$v.new_password.required && errors.push("New password is required.");
      !this.$v.new_password.minLength && errors.push("New password must be at least 8 characters.");
      !this.$v.new_password.validateString && errors.push("New password must contain one alphabet, one uppercase, one lowercase, one number and one special character.");
      return errors;
      },
      confirm_new_passwordErrors () {
       const errors = [];
       this.serverError = '';
       this.isAddClassServerError = '';
      if (!this.$v.confirm_new_password.$dirty) return errors;
      !this.$v.confirm_new_password.required && errors.push("Confirm New Password is required.");
      this.$v.confirm_new_password.required && !this.$v.confirm_new_password.sameAsPassword  && errors.push("Confirm New Password must match with password.");
      return errors;
      },
      buttonErrorMessage(){
      if (this.$v.$invalid) {
          this.isFormValid = false;
        }else{
          this.isFormValid = true;
        }
    },
    },

  created(){
    this.old_password='';
    this.new_password='';
    this.confirm_new_password='';
  },

  methods: {
    submit(e){
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$loading(true)
      const oldPassword = this.old_password;
      const newPassword = this.new_password;
      //console.log(oldPassword,newPassword);

      Auth.currentAuthenticatedUser()
        .then(user => {
          this.email = user.attributes.email;
          this.name =  user.attributes['custom:name'];
          this.mobile_no = '+91'+user.attributes['custom:phonenumber'];
          this.$loading(false);
          if(oldPassword == newPassword)
          {
            this.isAddClassServerError = true;
            this.serverError= "New Password should not be same as Current password";
            return ;
          }

          return Auth.changePassword(user, oldPassword, newPassword).then(data => {
        
          swal.fire({
            icon:'info',
            title: 'Your password changed successfully. You need to login again',
            showCancelButton: false,
            confirmButtonColor: `#051d42`,
            confirmButtonText: `OK`,
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$store.dispatch(CHANGE_PASSWORD, {
                data: {
                  email: this.email,
                  name:this.name,
                  mobile_no:this.mobile_no,
                  type:"change_password",
                },
                api: 'change-password-notification', 
              }).then(() => {
                this.$loading(false);
                let response = this.$store.getters.getChangePassword.data;
                if(response.status == 'error'){
                  this.isAddClassServerError = true;
                  this.serverError = response.message;
                  return [];
                }
              })
              .catch((error) =>  {
                this.$loading(false);
              })
              Auth.signOut().
              then(data => {
                Toast.fire({
                  icon: 'success',
                  title: 'Logout successfully.'
                })
                this.$router.push({ name: 'Login' }).catch(()=>{});
              })
              .catch(err => {
                this.$loading(false); 
              });
            } 
          })
        })
      .catch(err => {
        this.isAddClassServerError = true;
        if (err.message == 'Incorrect username or password.') {
          this.serverError = "Current password does not match";
        }else{

          this.serverError = err.message;
        }
        this.$loading(false);

      });
      }).catch(err => {
          this.isAddClassServerError = true;
          this.serverError = err.message;
          this.$loading(false);
        });
        // this.$router.push({ name: 'Login' }).catch(()=>{});
    },
    backButton(evt){
      evt.preventDefault();
      this.$router.push({ name: 'EditProfile' }).catch(()=>{});
    },
    showPassword() {
      if (this.passwordType == 'password') {
          this.passwordType = 'text';
          this.status = 'Hide Password';
          this.btnText =  'Hide';
      }
      else{
          this.passwordType = 'password';
          this.status = 'Show Password';
          this.btnText= 'Show';
      }
    },
    showPassword1() {
      if (this.passwordType1 == 'password') {
          this.passwordType1 = 'text';
          this.status1 = 'Hide Password';
          this.btnText1 =  'Hide';
      }
      else{
          this.passwordType1 = 'password';
          this.status1 = 'Show Password';
          this.btnText1 = 'Show';
      }
    }  
  }
  }
</script>
<style scoped>
   .error-messagebox-login{
      font-style: inherit !important;
   }
</style>